import { atom, type WritableAtom } from "jotai";
import { Dispatch } from "react";

export type Thunk<TState, TAction> = (
    dispatch: Dispatch<TAction>,
    getState: () => TState
) => void | Promise<void>;

export type Reducer<TState, TAction> = { defaultState: TState } & ((
    state: TState,
    action: TAction
) => TState);

export function atomWithThunksReducer<TState, TAction>(
    initialValue: TState,
    reducer: Reducer<TState, TAction>
) {
    return atom(
        initialValue,
        async function (
            this: WritableAtom<TState, [TState], void>,
            get,
            set,
            action: TAction | Thunk<TState, TAction>
        ) {
            if (action instanceof Function) {
                // If the action is a thunk, call it with the dispatch function
                return await action(
                    (action: TAction) => set(this, reducer(get(this), action)),
                    () => get(this)
                );
            }
            set(this, reducer(get(this), action));
        }
    );
}
